import { localizationService } from '@shared-services/localization-service';

export const getConfirmationString = (key: string) => {
    return localizationService.str(
        `ui.runtimessr.calbooking.confirmation.success.${key}`
    );
};
